import { Navigate, Outlet, createFileRoute, useRouterState } from "@tanstack/react-router";

import { Route as UpdatesRegionByIdRoute } from "src/app/routes/updates.regions.$regionId";
import { routeMatches } from "src/lib/vendor/tanstack/reactRouter/utils";

export const Route = createFileRoute("/updates/regions/$regionId/localities")({
  beforeLoad({ params }) {
    return { pageName: params.regionId };
  },

  component: RouteComponent
});

export function RouteComponent() {
  const { matches } = useRouterState();

  if (routeMatches(matches, "/updates/regions/$regionId/localities")) {
    return <Navigate to={UpdatesRegionByIdRoute.id} replace params />;
  }

  return <Outlet />;
}
